__turbopack_context__.v({
  "currencyItem": "UserMenu-module__k3ZcPa__currencyItem",
  "link": "UserMenu-module__k3ZcPa__link",
  "linksWrapper": "UserMenu-module__k3ZcPa__linksWrapper",
  "localeGroup": "UserMenu-module__k3ZcPa__localeGroup",
  "section": "UserMenu-module__k3ZcPa__section",
  "sectionText": "UserMenu-module__k3ZcPa__sectionText",
  "selects": "UserMenu-module__k3ZcPa__selects",
  "sessionText": "UserMenu-module__k3ZcPa__sessionText",
  "subtext": "UserMenu-module__k3ZcPa__subtext",
  "wrapper": "UserMenu-module__k3ZcPa__wrapper",
});
